import {GUEST_THEME_STORAGE_KEY} from '@toolify/client/src/modules/authentication/constants/guestAppearanceStorageKeys'
import {ThemeType} from '@toolify/server/src/services/UserSettingsService/strategies/ThemeUserSettingStrategy/enum/ThemeType'

export function setStoredGuestTheme(theme: ThemeType): void {
  if(typeof localStorage === 'undefined') {
    return
  }
  localStorage.setItem(GUEST_THEME_STORAGE_KEY, theme)
}
